// extracted by mini-css-extract-plugin
export var explainable = "_jw-a";
export var printerCard = "_jw-1";
export var printerCardConfigured = "_jw-2";
export var printerCardError = "_jw-3";
export var printerCardsContainer = "_jw-0";
export var printerIcon = "_jw-8";
export var printerIconConfigured = "_jw-5";
export var printerIconContainer = "_jw-4";
export var printerIconError = "_jw-6";
export var printerIconUnconfigured = "_jw-7";
export var workstationsTableCard = "_jw-9";